import { COLORS } from '@alto/design-library-tokens';
import { AltoIcon, Body, Pressable, Row } from '@alto/design-system';
import React from 'react';
import { push } from 'react-router-redux';
import { useDispatchShared } from '~shared/store';

type Props = {
  readonly href?: string;
  readonly to?: string;
  readonly text: string;
};

export const BackLink = ({ href, text, to = '/' }: Props) => {
  const dispatch = useDispatchShared();

  return (
    <Pressable
      aria-label={text}
      onPress={() => {
        if (href) {
          window.location.href = href;
        } else {
          dispatch(push(to));
        }
      }}
    >
      <Row centerVertically>
        <AltoIcon
          name="chevronleft-small"
          type="secondary"
        />
        <Body color={COLORS.TEXT_COLORS.SECONDARY}>{text}</Body>
      </Row>
    </Pressable>
  );
};
